import { Outlet } from 'react-router-dom';

import AuthRoute from '@components/auth/AuthRoute';

const MainView = () => {
  return (
    <AuthRoute>
      <Outlet />
    </AuthRoute>
  );
};

export default MainView;
